import ApiService from '@/core/services/api.service';
const resource = 'v1/approval-configs';

export default {
  /**
   * Fetch approval configs with pagination and filtering
   *
   * @param {Object} params - Query parameters
   * @returns {Promise} - Promise with the response data
   */
  async fetchAll(params = {}) {
    try {
      const response = await ApiService.query(resource, { params });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching approval configs:', error);
      throw error;
    }
  },

  /**
   * Delete an approval config
   *
   * @param {string|number} id - ID of the approval config to delete
   * @returns {Promise} - Promise with the response data
   */
  async delete(id) {
    try {
      const response = await ApiService.delete(`${resource}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting approval config:', error);
      throw error;
    }
  },

  /**
   * Get approval config by ID
   *
   * @param {string|number} id - ID of the approval config
   * @returns {Promise} - Promise with the response data
   */
  async getById(id) {
    try {
      const response = await ApiService.get(`${resource}/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching approval config:', error);
      throw error;
    }
  },

  /**
   * Create a new approval config
   *
   * @param {Object} payload - The approval config data
   * @returns {Promise} - Promise with the response data
   */
  async create(payload) {
    try {
      const response = await ApiService.post(resource, payload);
      return response.data;
    } catch (error) {
      console.error('Error creating approval config:', error);
      throw error;
    }
  },

  /**
   * Update an existing approval config
   *
   * @param {Object} payload - The approval config data
   * @returns {Promise} - Promise with the response data
   */
  async update(payload) {
    try {
      const response = await ApiService.put(resource, payload);
      return response.data;
    } catch (error) {
      console.error('Error updating approval config:', error);
      throw error;
    }
  },

  /**
   * Get approval config by type
   *
   * @param {number} type - The approval type
   * @returns {Promise} - Promise with the response data
   */
  async getByType(type) {
    try {
      const response = await ApiService.get(`${resource}/by-type/${type}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching approval config by type:', error);
      throw error;
    }
  },
};
